import API_CONFIG from '../config/api';

const getHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${token}`
  };
};

// Helper to construct URL safely
const getEndpoint = (path) => {
  // 1. Get Base URL (default to localhost if missing)
  const baseUrl = API_CONFIG.BASE_URL || 'http://localhost:5001';
  
  // 2. Get Prefix (Hardcode '/api' as fallback if config is missing)
  const prefix = API_CONFIG.API_PREFIX || '/api'; 
  
  // 3. Get Version (Hardcode 'v1' as fallback)
  const version = API_CONFIG.API_VERSION || 'v1';
  
  // 4. Clean up slashes to avoid double //
  const cleanBase = baseUrl.replace(/\/$/, '');
  
  // 5. Construct full URL: http://localhost:5001/api/v1/audit
  return `${cleanBase}${prefix}/${version}${path}`;
};

const AuditService = {
  getLogs: async (params = {}) => {
    try {
      const queryString = new URLSearchParams(params).toString();
      const url = getEndpoint(`/audit?${queryString}`); // <--- Uses safe helper

      const response = await fetch(url, {
        method: 'GET',
        headers: getHeaders(),
      });

      if (!response.ok) {
        // If 404, return empty list instead of crashing
        if (response.status === 404) return { success: true, data: [], pagination: { total: 0 } };
        const error = await response.json();
        throw new Error(error.message || 'Failed to fetch audit logs');
      }

      return await response.json();
    } catch (error) {
      console.error('AuditService getLogs error:', error);
      // Return safe empty object to prevent UI crash
      return { success: false, data: [], pagination: { total: 0, pages: 0, page: 1 } };
    }
  },

  exportLogs: async () => {
    try {
      const url = getEndpoint('/audit/export'); // <--- Uses safe helper
      
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
      });

      if (!response.ok) throw new Error('Export failed');

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = `audit_trail_export_${new Date().toISOString().split('T')[0]}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
      
      return true;
    } catch (error) {
      console.error('AuditService export error:', error);
      throw error;
    }
  }
};

export default AuditService;